import BaseService from "./BaseService";

export class UserConfigurationService extends BaseService {
    protected urlBase: string = "api/User";

    public async getUserConfiguration(key: string) {
        const params = new URLSearchParams({});
        const res = await this.get(params, "Configurations");
        return res;
    }
    
    public async updateUserConfiguration(key: string, value: string) {
        const params = new URLSearchParams({});
        const res = await this.put(
            params,
            "Configurations",
            JSON.stringify({ "UserConfigurations": { [key]: value } }),
        );
        return res;
    }
    public async deleteUserConfiguration(key: string, value: string) {
        const params = new URLSearchParams({});
        const res = await this.delete(
            params,
            "Configurations",
            JSON.stringify({ "UserConfigurations": { [key]: value } }),
        );
        return res;
    }
}
